import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { faLockAlt } from '@fortawesome/pro-duotone-svg-icons';
import { startCreatingEmailPasswordAccount } from '../../actions/user';
import LoadingView from '../view-loading';
import SetPasswordView from '../view-set-password';
import { SetPasswordWrapper, SetPasswordIcon, SetPasswordTitle } from './styled';
const SetPasswordPage = props => [{
  cond: props.hasCredentialsAccount,
  view: () => /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })
}, {
  cond: props.accountLinkingLoading,
  view: () => /*#__PURE__*/React.createElement(LoadingView, null)
}, {
  cond: true,
  view: () => /*#__PURE__*/React.createElement(SetPasswordWrapper, null, /*#__PURE__*/React.createElement(SetPasswordTitle, null, /*#__PURE__*/React.createElement(SetPasswordIcon, {
    icon: faLockAlt
  }), /*#__PURE__*/React.createElement("br", null), "C'est le moment de cr\xE9er", /*#__PURE__*/React.createElement("br", null), "votre mot de passe !"), /*#__PURE__*/React.createElement(SetPasswordView, {
    submitPassword: props.startCreatingEmailPasswordAccount,
    loading: props.createEmailPasswordAccountLoading,
    error: props.createEmailPasswordAccountError || props.accountLinkingError
  }))
}].find(x => x.cond).view();
const mapStateToProps = _ref => {
  let {
    user
  } = _ref;
  return {
    createEmailPasswordAccountLoading: user.createEmailPasswordAccountLoading,
    createEmailPasswordAccountError: user.createEmailPasswordAccountError,
    accountLinkingLoading: user.accountLinkingLoading,
    accountLinkingError: user.accountLinkingError,
    hasCredentialsAccount: user.decodedAccessToken[window.processRuntime.env?.AUTH0_CUSTOM_CLAIM_DOMAIN + '/hasCredentialsIdentity'] || false
  };
};
const mapDispatchToProps = dispatch => ({
  startCreatingEmailPasswordAccount: password => dispatch(startCreatingEmailPasswordAccount(password))
});
SetPasswordPage.propTypes = {
  createEmailPasswordAccountLoading: PropTypes.bool.isRequired,
  createEmailPasswordAccountError: PropTypes.object,
  accountLinkingLoading: PropTypes.bool.isRequired,
  accountLinkingError: PropTypes.object,
  startCreatingEmailPasswordAccount: PropTypes.func.isRequired,
  hasCredentialsAccount: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(SetPasswordPage);